import createHttp from '@/config/http';
import type { Provider } from '@/types/contact';
import type { IResponseFetch, ResponseMetaData } from '@/types/service';

const http = createHttp(import.meta.env.VITE_PATIENT_URL);

// Physician Types
export interface Physician extends Provider {
	// contactid: string;
	providerId: string;
	providername: string;
}

// Shipping Location Types
export interface ShippingLocation {
	ta_shippinglocationsid: string;
	ta_name: string;
	ta_addressline?: string;
	ta_citylocality?: string;
	ta_stateprovince?: string;
	ta_postalcode?: string;
	ta_telephone1?: string;
}

// ========== PHYSICIANS ==========
export const getPhysicians = async (
	clinic_id?: string,
	page = 1,
	limit = 50,
	search = '',
	sort = '',
): Promise<{
	items: Physician[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<IResponseFetch<Physician>>(
		'/physicians/ternary-db',
		{
			params: {
				...(clinic_id && { clinic_id }),
				page,
				limit,
				search,
				sort,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

// ========== SHIPPING LOCATIONS ==========
export const getShippingLocations = async (
	account_id?: string,
	page = 1,
	limit = 50,
	search = '',
	sort = '',
): Promise<{
	items: ShippingLocation[];
	meta: ResponseMetaData;
}> => {
	if (!account_id) {
		return {
			items: [],
			meta: { totalRecords: 0, currentPage: 1, itemsPerPage: 0, totalPages: 0 },
		};
	}

	const response = await http.get<IResponseFetch<ShippingLocation>>(
		'/accounts/shipping-locations',
		{
			params: {
				account_id,
				page,
				limit,
				search,
				sort,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};
